import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatFileFoundEvent} from '../types/events'
import {NinchatState} from 'api/types'
import {extractProperties} from '.'

export const fileFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        file_id,
        ...properties
    } = extractProperties<NinchatFileFoundEvent>(action.payload)

    const _file = state._files[file_id]

    if (!_file) {
        return
    }

    const chatId = _file.channel_id ?? _file.user_id

    if (!chatId) {
        return
    }

    const _message = state._messages[chatId].messages.find((message) => message.message_id === _file.message_id)

    if (!_message) {
        return
    }

    _file.url_expiry = properties.url_expiry

    _message._revision = Date.now()
    _message.files = (_message.files ?? []).map((file) => {
        if (file.file_id !== file_id) {
            return file
        }

        return {
            ...file,
            ...properties,
        }
    })
}
